// import axios from 'axios';

// export const fetchViewers = () => async dispatch => {
//   const {data} = await axios.get('/api/viewers.json')
//   dispatch({
//     type: 'VIEWERS_SUCCESS',
//     data
//    })
//  }

const initialState = {
  loading: true,
  viewers: []
}

export default (state = initialState, action) => {
  switch (action.type) {
    case 'FETCH_PROJECT_SUCCESS':
      
      return {
        ...state,
        ...action.data,
        viewers: action.data.viewers.map(viewer => ({...viewer, loaded: false})),
        loading: false
      };
    case 'FETCH_VIEWER_SUCCESS':
       
        window.top.data=action.data;
        
      return {
        ...state,
        viewers: [
          ...(state.viewers.filter(item => item.id !== action.data.id)),
          {
            ...action.data,
            loaded: true
          }
        ]
      };
    case 'SAVE_VIEWER_SUCCESS':
      return {
        ...state,
        viewers: [
          ...state.viewers.filter(item => item.id !== action.data.id),
          {
            ...action.data,
            loaded: true
          }
        ]
      };
    default:
      return state;
  }
};
